
import { useState, useEffect } from 'react'
import { getMUICache, getUrl, appendStyleSheet, getEndpoint, getSocialClassName, getImageUrl, fetchAnchorValue , GetIconsSprites} from "../../../common/utils";

import { CacheProvider } from '@emotion/react';
//import { FoontAwesomeIcon } from '@fortawesome/react-foontawesome';
import Grid from '@mui/material/Grid';
import bcrypt from 'bcryptjs-react';
import './FooterTwo.css';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import {ImageLoader} from '../../../components/IntersectionObserver/imageComponent';
import { PAGEBUILDER_URLS } from '../../Common/Constant';


FooterTwo.version = 1000;

FooterTwo.lang = 'en';
FooterTwo.langs = [
    'en'
];
FooterTwo.setLang = (lang: any) => {
    FooterTwo.lang = lang;
}

Object.defineProperty(FooterTwo, 'name', {
    writable: true,
    value: 'FooterTwo'
});

// Define a type for the fetch options
interface FetchOptions {
    method: string;
    headers: {
        'Content-Type': string;
        'p-nonce': string;
    };
    credentials?: RequestCredentials; // Use RequestCredentials type
}

export function FooterTwo(props: any) {

    const { anchorLinksValue } = props;
    ImageLoader();
    // EagerLoadImages();
    // AddImageDimensions();
    // SetHighPriorityImages();

    const [menuItems, setMenuItems] = useState<any>([]);
    const [footerData, setFooterData] = useState<any>({});
    const cache = getMUICache();
    const { showStaticPages, showSocialIcons, copyRightText, BgColor, TextColor, noOfHeaderItems } = props;
    let styles = require("./FooterTwo.css");
    appendStyleSheet("FooterTwo", styles);
    const endpoint = getEndpoint(props, "MAIN");
    const footerMenuEndpoint = getEndpoint(props, "FOOTER_MENU_API");
    useEffect(() => {
        if (!endpoint.isSSR || !endpoint.SSRDataObj || !footerMenuEndpoint.isSSR || !footerMenuEndpoint.SSRDataObj) {
            fetchComponentData();
        }
    }, []);

    if (endpoint.isSSR && endpoint.SSRDataObj && (!footerData || !Object.keys(footerData).length)) {
        setFooterData(endpoint.SSRDataObj);
    }

    if (footerMenuEndpoint?.isSSR && footerMenuEndpoint?.SSRDataObj && footerMenuEndpoint?.SSRDataObj.length && (!menuItems || !menuItems.length)) {
        setMenuItems(footerMenuEndpoint.SSRDataObj);
    }
    const fetchComponentData = () => {
        const { ENDPOINTS } = props;

        let footerAPI = getUrl(props, 0, false, "MAIN", true, ENDPOINTS[0].queryParams.websiteId, ENDPOINTS[0].queryParams.clientId);
        let menuAPIurl = getUrl(props, 0, false, "FOOTER_MENU_API", true);

        let headerString = `?` + footerAPI.split("?")[1];
        headerString = bcrypt.hashSync(headerString, 6);
        const customHeaders = {
            'Content-Type': 'application/json',
            'p-nonce': headerString
        };
        var fetchOptions: FetchOptions = {
            method: 'GET',
            headers: customHeaders
        };

        let headerString_menuAPIurl = '?' + menuAPIurl.split("?")[1];
        headerString_menuAPIurl = bcrypt.hashSync(headerString_menuAPIurl, 6);
        const headers_menuAPIurl = { 'p-nonce': headerString_menuAPIurl };

        if (footerAPI.includes('getsiteResources') && !footerAPI.includes("rendering/getsiteResources") &&
            (typeof document !== 'undefined' && undefined !== document && document
                && !PAGEBUILDER_URLS.some(domain => window.location.origin.includes(domain)))) {
            footerAPI = footerAPI.replace("getsiteResources", "rendering/getsiteResources");
        } else { fetchOptions.credentials = "include"; }
        Promise.all([
            fetch(footerAPI, fetchOptions).then((response) => response.json()),
            fetch(menuAPIurl, { headers: headers_menuAPIurl }).then((response) => response.json()),
        ])
            .then(([result1, result2]) => {
                // Handle the results individually
                setFooterData(result1);
                setMenuItems(result2);
            })
            .catch((error) => {
                // Handle errors here
                console.error('Error fetching data:', error);
            });
    }


    const renderStaticPages = () => {
        if (!footerData.staticPages) {
            return false;
        }
        let listItems = footerData.staticPages.map((val: any, index: number) => {
            return <li key={'ff_' + index} ><a href={val.sourcePath} target={fetchAnchorValue(anchorLinksValue, val.sourcePath)} style={{ color: TextColor }}>{val["name"]}</a></li>
        })
        return (<ul>{listItems}</ul>)
    }


    const getMenuItems = () => {

        if (!Array.isArray(menuItems)) {
            return null; 
        }

        let menuData = menuItems.slice(0, noOfHeaderItems);

        return <ul>
            {menuData.map((val: any, i: any) => {
                let morePath: string = val.path;
                if (val.type === 2) {
                    morePath = '/tags/' + (val.tagpath !== undefined ? val.tagpath : '');
                }
                return <li className='nav-item' key={i}><a className='navlink' href={morePath} target={fetchAnchorValue(anchorLinksValue, morePath)}  style={{ color: TextColor }}>{val.name}</a></li>
            })
            }
        </ul>

    }
    const renderSocialIcons = () => {
        if (!footerData.socialPlatformList) {
            return false;
        }
        let html = <div className="socialMediaWrap">
            <ul className='footerSocialList'>
                {footerData?.socialPlatformList.filter((item: any) => item.url.trim() !== '').map((val: any, i: any) => {
                    let iconType = getSocialClassName(val.name, 2);
                    return <li key={i}><a key={i} href={val.url} target="_blank" aria-label="social shares">
                        
                        {/* <FoontAwesomeIcon icon={iconType} /> */}
                        <div className={`sprite-icon ${iconType}`} style={{ backgroundImage: `url(${GetIconsSprites()})` }}/>
                        </a></li> 
                })
                }
            </ul>
        </div>
        return html;
    }

    return (
        <div className='commoncontainerFooter' style={{ backgroundColor: BgColor }}>
            <CacheProvider value={cache}>
                <div className='themeTwoFooterWrapper'>
                    <div className='tempdiv fix-wrapper'>
                        <div className='footerLogoImageWrap'>
                            <a href="/" aria-label="logo" target="_self" className="main-logo">
                                {footerData.footerLogo && <img className='desktopFooterLogoImge' data-src={getImageUrl(footerData.footerLogo, "422424", 96, undefined, "", false, props.CONSTANTS)} alt="logo" title="logo" width="96" height="36" />}
                            </a>

                            <div className='mobilefooterdicription footerTextWrap'>
                                {props.showAbout && <p>
                                    {footerData.footerLogo && <a href="/" aria-label="logo" target="_self" className="main-logo">
                                        <img className='mobileFooterLogoImge' data-src={getImageUrl(footerData.footerLogo, "422424", 96, undefined, "", false, props.CONSTANTS)} alt="logo" title="logo" width="96" height="36" />
                                    </a>
                                    }
                                    {footerData && footerData?.aboutSiteContent}</p>}
                            </div>
                        </div>
                        <div className='desktopfooterdicription footerTextWrap'>
                            {props.showAbout && <p>{footerData && footerData?.aboutSiteContent}</p>}
                        </div>
                    </div>
                </div>
                <div className='footerLinksSectionWrap fix-wrapper'>
                    <Grid container spacing={2}>
                        <Grid item md={9} xs={12}>
                            <div className='footerLinksMainWrap'>
                                <div className='footerLeftSectionLink'>
                                    <div className='footerLeftSectionHeading' style={{ color: TextColor }}>Section</div>
                                    {menuItems && getMenuItems()}

                                </div>

                                <div className='footerLeftSectionLink'>
                                    {showStaticPages && <div className='footerLeftSectionHeading' style={{ color: TextColor }}>Company</div>}
                                    {showStaticPages && renderStaticPages()}

                                </div>
                            </div>
                        </Grid>
                        <Grid item md={3} xs={12}>
                            <div className='footerAdressWrapper'>
                                {showSocialIcons && <div className='footerAdressHeading' style={{ color: TextColor }}>Follow us</div>}
                                {showSocialIcons && renderSocialIcons()}
                                <div className='footerAdressHeading' style={{ color: TextColor }}>Contact</div>
                                <ul className='footerAdressMainWrap'>
                                    <li>
                                        <PlaceOutlinedIcon /><span style={{ color: TextColor }}>{footerData && footerData?.contactUs}</span>
                                    </li>
                                    <li>
                                        <MailOutlinedIcon /><a href={`mailto:${props.supportEmail}`} style={{ color: TextColor }}>{footerData && footerData?.supportEmail}</a>
                                    </li>
                                </ul>
                            </div>
                        </Grid>
                    </Grid>
                </div>
                <div className='bottomFooterTheme'>
                    <p>{copyRightText ? copyRightText : footerData.copyRightContent}</p>
                </div>
            </CacheProvider>
        </div>

    )

}

